let env = {};

// env.baseURL = 'http://api.ama-doroteia.ares-saude.com.br/api/v1/';
// env.normalURL = 'http://api.ama-doroteia.ares-saude.com.br/';
// env.webserviceHost = '179.190.28.108';
// env.webservicePort = '6001';

// env.baseURL = 'http://api.triagem.ares-saude.com.br/api/v1/';
// env.normalURL = 'http://api.triagem.ares-saude.com.br/';
// env.webserviceHost = '179.190.28.108';
// env.webservicePort = '6001';

// env.baseURL = 'http://api.triagem-sp.ares-saude.com.br/api/v1/';
// env.normalURL = 'http://api.triagem-sp.ares-saude.com.br/';
// env.webserviceHost = '179.190.28.108';
// env.webservicePort = '6001';

//UPA ICARAI
// env.baseURL = 'https://api.upaicarai.ares-triagem.com.br/api/v1/';
// env.normalURL = 'https://api.upaicarai.ares-triagem.com.br/';
// env.webserviceHost = 'websocket.upaicarai.ares-triagem.com.br';
// env.wsPort = '443';
// env.wsKey = 'triagem-key';


// env.baseURL = 'http://localhost:8000/api/v1/';
// env.normalURL = 'http://localhost:8000/';
// env.wsHost = 'localhost';
// env.wsPort = '8081';
// env.wsKey = 'triagem-hml-local-key';

env.baseURL = 'https://api.triagem-hml.ares-saude.com.br/api/v1/';
env.normalURL = 'https://api.triagem-hml.ares-saude.com.br/';
env.wsHost = 'websocket.triagem-hml.ares-saude.com.br';
env.wsPort = '443';
env.wsKey = 'triagem-hml-local-key';

// env.baseURL = 'https://api.apresentacao.ares-triagem.com.br/api/v1/';
// env.normalURL = 'https://api.apresentacao.ares-triagem.com.br/';
// env.wsHost = 'websocket.apresentacao.ares-triagem.com.br';
// env.wsKey = 'triagem-apresentacao-key';


export default env
